import { queryOptions, useQuery } from '@tanstack/react-query';

import { fetchFn, QueryConfig } from '@/lib/react-query';

interface GetWaypointsPicturesParams {
  waypointIds: number[];
}

export interface WaypointPicture {
  id: number;
  issuedAt: string;
  photo: string;
  waypointId: number;
}

const getWaypointPicturesFn = (params: GetWaypointsPicturesParams): Promise<WaypointPicture[]> =>
  fetchFn('/waypoints/pictures', {
    params,
  });

export const getWaypointPicturesQueryOptions = (params: GetWaypointsPicturesParams) => {
  return queryOptions({
    queryKey: ['waypoint-pictures', params],
    queryFn: () => getWaypointPicturesFn(params),
  });
};

type UseWaypointPicturesOptions = {
  params: GetWaypointsPicturesParams;
  queryConfig?: QueryConfig<typeof getWaypointPicturesQueryOptions>;
};

export const useGetWaypointPictures = ({ params, queryConfig }: UseWaypointPicturesOptions) => {
  return useQuery({
    ...getWaypointPicturesQueryOptions(params),
    ...queryConfig,
  });
};
